import React from 'react';
import Line from '@splunk/dashboard-visualizations/Line';

export default () => (
    <Line
        encoding={{
            x: 'primary.sourcetype',
            y: 'primary[1:]',
        }}
        dataSources={{
            primary: {
                requestParams: { offset: 0, count: 20 },
                data: {
                    fields: [
                        {
                            name: 'sourcetype',
                        },
                        {
                            name: 'count',
                            type_special: 'count',
                        },
                        {
                            name: 'percent',
                            type_special: 'percent',
                        },
                    ],
                    columns: [
                        [
                            'splunkd',
                            'splunkd_ui_access',
                            'splunkd_access',
                            'splunk_web_access',
                            'scheduler',
                            'splunk_web_service',
                        ],
                        ['600', '525', '295', '213', '122', '19'],
                        ['87.966380', '50.381304', '60.023780', '121.183272', '70.250513', '90.194752'],
                    ],
                },
                meta: { totalCount: 20 },
            },
        }}
    />
);
